// ReportTimeDescCell Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import CellContainer from '../../../../components/ListCell/CellContainer.jsx'

class ReportTimeDescCell extends Component {
  static get propTypes () {
    return {
      info: PropTypes.shape({
        value: PropTypes.string
      }),
      width: PropTypes.string,
      onView: PropTypes.func,
      tooltip: PropTypes.string,
      tooltipPosition: PropTypes.oneOf(['right', 'left', 'bottom', 'top']),
      className: PropTypes.string,
      defaultValue: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      info: null,
      width: null,
      onView: null,
      tooltip: '',
      tooltipPosition: 'right',
      className: '',
      defaultValue: '-'
    }
  }

  constructor (props) {
    super(props)

    this.state = {
      tooltipStyle: null,
      tipClassName: ''
    }
  }

  render () {
    const {
      info,
      onView,
      tooltip,
      tooltipPosition,
      className,
      defaultValue,
      width
    } = this.props
    const { tipClassName } = this.state

    const tooltipPositionClass = `tip${tooltipPosition}`
    const _class = classnames(
      'report-time-desccell list-cell',
      tooltipPositionClass,
      className
    )
    const TotalLetterCount = info && info.value ? info.value.length : 0

    return (
      <CellContainer width={width} className={_class}>
        <div className='listrowcell' onClick={onView}>
          {info && info.value ? (
            <div dangerouslySetInnerHTML={{ __html: info.value }} />
          ) : (
            defaultValue
          )}
          {tooltip && TotalLetterCount > 27 ? (
            <span className='tooltip'>
              <span dangerouslySetInnerHTML={{ __html: tooltip }} />
              <span
                className={`tip${tipClassName ? ' ' + tipClassName : ''}`}
              />
              <span
                className={`tipicon${tipClassName ? ' ' + tipClassName : ''}`}
              >
                <i className='icon icon-common-infotip' />
              </span>
            </span>
          ) : null}
        </div>
      </CellContainer>
    )
  }
}

export default ReportTimeDescCell
